<div
  class="min-h-screen flex items-center justify-center px-4"
  style="background: linear-gradient(135deg, color-mix(in srgb, var(--color-primary) 8%, white), white 45%, color-mix(in srgb, var(--color-accent) 12%, white));"
>
  <div
    class="w-full max-w-md bg-white/90 backdrop-blur rounded-3xl shadow-xl border border-[color:var(--color-primary)]/10 p-8"
  >
    <!-- Logo -->
    <div class="flex flex-col items-center mb-8">
      <img src="assets/logo.svg" [alt]="'Logo ' + institutionName" class="h-16" />
    </div>

    <!-- Formulario -->
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-4">
      <mat-form-field appearance="outline" class="w-full cursor-pointer">
        <mat-label>Email</mat-label>
        <input matInput type="email" placeholder="Ingresar Email" formControlName="email" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full cursor-pointer">
        <mat-label>Contraseña</mat-label>
        <input
          matInput
          [type]="hidePassword ? 'password' : 'text'"
          placeholder="Ingresar Contraseña"
          formControlName="password"
        />
        <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword">
          <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </mat-form-field>

      <button
        type="submit"
        [disabled]="form.invalid"
        class="font-semibold rounded-xl w-full py-3 transition-all bg-[var(--color-primary)] hover:brightness-110 cursor-pointer text-white disabled:bg-gray-300 disabled:text-gray-500 disabled:cursor-not-allowed"
      >
        Acceder
      </button>
      <div class="text-center">
        <button
          (click)="gotoForgotPassword()"
          class="text-sm text-[var(--color-primary)] hover:underline cursor-pointer"
        >
          ¿Olvidaste tu contraseña?
        </button>
      </div>
    </form>
  </div>
</div>
